import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import {
  renderCustomColumnDefs,
  renderValidations,
} from "../../../shared/Table/table.utils";
import CustomerTagsInline from "./CustomerTagsInline";

// Config for table and form
const tableConfig = [
  {
    id: "name",
    minWidth: 220,
    enableGlobalFilter: true,
    cell: ({ row: { original }, getValue }) => {
      return (
        <Link
          className="text-primary-600 hover:underline"
          to={`/admin/customers/${original._id}`}
        >
          {getValue()}
        </Link>
      );
    },
  },
  {
    id: "phone",
    minWidth: 140,
    enableGlobalFilter: true,
  },
  {
    id: "email",
    minWidth: 220,
    enableGlobalFilter: true,
    cell: ({ getValue }) => <span className="break-all">{getValue()}</span>,
  },
  {
    id: "slug",
    minWidth: 160,
    enableGlobalFilter: true,
  },
  {
    id: "tags",
    header: "Tags",
    minWidth: 220,
    cell: ({ row: { original } }) => (
      <div onClick={(event) => event.stopPropagation()}>
        <CustomerTagsInline customer={original} summarizeOverflow />
      </div>
    ),
  },
  {
    id: "active",
    width: 100,
    cell: ({ getValue }) => {
      return getValue() ? (
        <CheckCircleIcon className="w-5 h-5 text-green-500" />
      ) : (
        <XCircleIcon className="w-5 h-5 text-red-500" />
      );
    },
  },
];

export const COLUMN_DEFINITIONS = renderCustomColumnDefs(tableConfig);
export const FORM_OPTIONS = { validations: renderValidations(tableConfig) };
export const PAGE_SIZE_OPTIONS = [
  { label: "10 Customers", value: 10 },
  { label: "20 Customers", value: 20 },
  { label: "50 Customers", value: 50 },
  { label: "100 Customers", value: 100 },
  { label: "150 Customers", value: 150 },
];
